import smoothScrollIntoView from "smooth-scroll-into-view-if-needed";
import { sleep_abit } from "./util_glob";

export const scrollToElementNoSmooth = (el: HTMLElement) => {
    import.meta.env.DEV && console.log("‹scrollToElementNoSmooth›", el);
    if (el) el.scrollIntoView({ behavior: "auto", block: "center" });
};
export const scrollToPageCSTM = (pN: number) => {
    import.meta.env.DEV && console.log("‹scrollToPageCSTM›", pN);
    var node = document.querySelector(`[data-page-number="${pN}"`);
    if (node) smoothScrollIntoView(node, { behavior: "smooth", block: "center" });
};
export const scrollToPageDefault = (pN: number) => {
    import.meta.env.DEV && console.log("‹scrollToPageDefault›", pN);
    var node = document.querySelector(`[data-page-number="${pN}"`);
    if (node) smoothScrollIntoView(node, { behavior: "smooth", block: "center" });
};
export const reendableUserScrollHandling = (src: string, tm: number = 500) => {
    import.meta.env.DEV && console.log("‹reendableUserScrollHandling›", tm, "src:", src);
    setTimeout(() => (window.globalUserScrollLazyLoadEnabled = true), tm);
};
export const scrollToPageNoSmooth = (pN: number, src: string) => {
    import.meta.env.DEV && console.log("‹scrollToPageNoSmooth›", pN, src);
    var node = document.querySelector(`[data-page-number="${pN}"`);
    if (node) node.scrollIntoView({ behavior: "auto", block: "center" });
};
export const scrollToPageNoSmoothCond = async (pN: number, srcLoc: number) => {
    import.meta.env.DEV && console.log("‹scrollToPageNoSmoothCond›", pN, "srcLoc:", srcLoc);
    var node = document.querySelector(`[data-page-number="${pN}"`);
    if (node) node.scrollIntoView({ behavior: "auto", block: "center" });
};
export const scrollToPageSmoothCond = (pN: number, srcLoc: number) => {
    import.meta.env.DEV && console.log("‹scrollToPageSmoothCond›", pN, "srcLoc:", srcLoc);
    if (Math.abs(pN - srcLoc) < 2) return;
    var node = document.querySelector(`[data-page-number="${pN}"`);
    if (node) smoothScrollIntoView(node, { behavior: "smooth", block: "center" });
};
export const scrollCustomAnimPage = (pg: number, curPage: number) => {
    import.meta.env.DEV && console.log("‹scrollCustomAnimPage›", pg, "curPage:", curPage);
    if (pg > curPage + 2) {
        scrollToPageNoSmooth(pg - 2,'‹scap_more›');
        setTimeout(() => scrollToPageDefault(pg), 50);
    } else if (pg < curPage - 2) {
        scrollToPageNoSmooth(pg + 2,'‹scap_less›');
        setTimeout(() => scrollToPageDefault(pg), 50);
    } else {
        setTimeout(() => scrollToPageDefault(pg), 50);
    }
    reendableUserScrollHandling('‹scrl_cap');
};
export const scrollCustomAnimElement = (pg: number, el: HTMLElement, scndEl: HTMLElement, curPage: number) => {
    import.meta.env.DEV && console.log("‹scrollCustomAnimElement›", pg, "curPage:", curPage, "el:", el, "scndEl:", scndEl);
    if (pg > curPage + 2) {
        scrollToPageNoSmooth(pg - 2,'‹sce_more›');
        setTimeout(() => {
            smoothScrollIntoView(el, { behavior: "smooth", block: "center" });
            setTimeout(() => {
                smoothScrollIntoView(el, { behavior: "smooth", block: "center" });
            }, 500);
        }, 50);
    } else if (pg < curPage - 2) {
        scrollToPageNoSmooth(pg + 2,'‹sce_less›');
        setTimeout(() => {
            smoothScrollIntoView(el, { behavior: "smooth", block: "center" });
            setTimeout(() => {
                smoothScrollIntoView(el, { behavior: "smooth", block: "center" });
            }, 500);
        }, 50);
    } else {
        setTimeout(() => {
            smoothScrollIntoView(el, { behavior: "smooth", block: "center" });
            setTimeout(() => {
                smoothScrollIntoView(el, { behavior: "smooth", block: "center" });
            }, 500);
        }, 50);
    }
    reendableUserScrollHandling('‹scrl_cae›', 500);
};
function sleep_async(arg0: number) {
    throw new Error("Function not implemented.");
}
